import { MenuPoint } from '../interfaces/menupoint.interface';

export function isRouteMenuPoint(menuPoint: MenuPoint | undefined | null): boolean {
	return (
		!!menuPoint?.url && !menuPoint.submenus?.length && !menuPoint.callback && !menuPoint.disabled
	);
}
